angular.module('jv.services')
.service('currentUserService', ['$window', function($window) {
    return $window._jvselfUser;
}]);
